import { RepositoryFactory } from '@/legacy/repositories/RepositoryFactory'
const StoreRepository = RepositoryFactory.get('store')

const SET_LOADING = 'SET_LOADING'
const SET_TRAFFIC_SOURCES = 'SET_TRAFFIC_SOURCES'

export default {
  namespaced: true,
  state: {
    trafficSourcesTemplates: [],
    loading: false,
  },
  getters: {
    trafficSourcesTemplates: (state) => state.trafficSourcesTemplates,
  },
  mutations: {
    [SET_TRAFFIC_SOURCES]: (state, trafficSources) =>
      (state.trafficSourcesTemplates = trafficSources),
    [SET_LOADING]: (state, loading) => (state.loading = loading),
  },
  actions: {
    async fetchTrafficSources({ rootState, commit }) {
      commit(SET_LOADING, true)
      try {
        const data = await StoreRepository.getTrafficSources(rootState.user.token)
        commit(SET_TRAFFIC_SOURCES, data)
      } catch {
        // swallow
      } finally {
        commit(SET_LOADING, false)
      }
    },
  },
}
